import React, { useState } from 'react';
import DatePicker from 'react-datepicker2';
import moment from 'moment-jalaali';
import * as Icons from "../../assets/SVGs/index"; 
import theme from "../../config/theme";
import { useSelector } from "react-redux";

interface PersianDatePickerProps {
  selectedDate: moment.Moment | undefined;
  onDateChange: (date: moment.Moment | undefined) => void;
}

const PersianDatePicker: React.FC<PersianDatePickerProps> = ({ selectedDate, onDateChange }) => {
  const [isFocused, setIsFocused] = useState(false); 

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => {
    if (!selectedDate) {
      setIsFocused(false); 
    }
  };

  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;

  return (
    <div className="relative flex flex-col gap-2 w-full">
      <div className="relative">
        <DatePicker
          value={selectedDate}
          onChange={(date) => {
            onDateChange(date);
            if (date) setIsFocused(true); 
          }}
          isGregorian={false} 
          timePicker={false} 
          onFocus={handleFocus} 
          onBlur={handleBlur}
          className="datepicker-input mb-4 peer block w-full rounded-md py-2.5 px-10 mb-1 border focus:outline-none"
        />
        <label
          style={{
            backgroundColor: mode.backgroundColor.bgSecondary,
            color: mode.color.textPrimary, 
          }}
          className={`absolute right-8 top-2 transform transition-all px-1 text-xs ${
            isFocused || selectedDate ? '-translate-y-3.5 text-sm bg-white !right-3' : 'translate-y-1 text-sm'
          }`}
        >
          تاریخ پروژه
        </label>
        <span className="absolute inset-y-0 right-2 -top-[15px] flex items-center pl-3 pointer-events-none">
          <Icons.CalenderIcon className="w-5 h-5" />
        </span>
      </div>
    </div>
  );
};

export default PersianDatePicker;
